<template>
  <div class="Info">
    <div class="title">{{title}}</div>
    <div class="panel">
      <div class="success">
        <img src="/oss/images/enroll/check-icon.png"/>
        <span>
          报名信息已提交
        </span>
      </div>
      <div>
        <start_button></start_button>
      </div>
      <div class="tips">
        <p>
          在获取题目前您需要支付一笔数额为￥299的费用以获得AI HackStack使用许可证，支付成功后即可自动获取AI HackStack使用许可证，通过AI HackStack来帮助您回答问题和方案设计。
        </p>
        <p>
          许可证使用时限为两个月
        </p>
        <p>
          点击登录AI HackStack？
        </p>
      </div>
    </div>
  </div>
</template>

<script>
 import MyButton from '@/components/Button.vue'
 import MyImage from '@/components/Image.vue';

 import groupS1 from '../../assets/image/enroll/group-s1.png'
 import groupS2 from '../../assets/image/enroll/group-s2.png'
 import groupM from '../../assets/image/enroll/group-m.png'
import StartButton from '@/components/contest/StartButton.vue'

 export default {
   name: 'Info',
   data () {
     return {
     }
   },
   methods: {
     start(){
       if(this.user){
         if(this.user.paid)
           {
             // modal
           }
         else
           {
             this.$modal.show('payment-modal')
           }
       }
       else
         {
           this.$router.push({name:'account', params:{type:'login'}})
         }

     }
   },
   computed: {
     title() {
       return '报名信息'
     },
     imgWidth() {
       return '4.75vw'
     },
     imgs() {
       return [groupS1, groupS2, groupM]
     },
     notice () {
       return this.$store.state.enroll.notice;
     },
     group() {
       let groups = this.$store.state.enroll.groups
       if (this.user.group === 5) {
          return {
            img: this.imgs[0],
            text: groups[0].text + groups[0].extra
          }
       }
       return {
         img: this.imgs[this.user.group],
         text:  groups[this.user.group].text + groups[this.user.group].extra
       }
     },
     buttonStyle () {
       return {
         'height': '2.6vw',
         'width': '160px'
       }
     },
     user() {
       return this.$store.state.auth.user
     }
   },
   components:{
     my_button: MyButton,
     my_image: MyImage,

     start_button: StartButton,
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .Info{
   width: 62.5vw;
   min-height: 60vh;
   box-sizing: border-box;
   padding-top: 2.4vw;
   padding-bottom: 2.13vw;
   padding-left: 4vw;
   padding-right: 4vw;
   /* background-image: url(~@/assets/image/enroll/bg-info.png); */
   display: flex;
   flex-direction: column;
   align-items:center;
   justify-content: space-between;
 }
 .title{
   color: white;
   font-size: 1.875vw;
   line-height: 1.85vw;
   display: flex;
   align-items:center;
   justify-content: center;
 }
 .panel{
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   justify-content:space-between;
 }

 .notice{
   width: 41.93vw;
   height: 11.77vw;
   color: white;
   line-height: 1.5625vw;
 }
 .group{
   text-align:center;
   color: white;
 }
 .button{
   width: 7.6vw;
   display: flex;
   height: 9vw;
   flex-direction: column;
   justify-content: space-between;
   position: relative;
 }
 .p, .c{
   min-width: 3.16vw;
   height: 1.6875vw;
   display: flex;
   box-sizing: border-box;
   align-items:center;
   justify-content:center;
   color: white;
   background-color: #BEBCFF;
 }

.success {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.success > img {
  width: 66px;
}
.success >span {
  font-size: 18px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 40px;
}
.tips {
  margin-top: 60px;
}
</style>
